import { FC, lazy, LazyExoticComponent, Suspense } from "react";
import { Navigate } from "react-router-dom";
import AuthGuard from "./components/authentication/AuthGuard";
import DashboardLayout from "./components/layouts/DashboardLayout";
import Coralogix from "pages/queries/Coralogix";
import Redash from "pages/queries/Redash";
import Jenkins from "pages/queries/Jenkins";
import { RoleProvider } from "./utils/RoleContext";
import RootGoogleHandler from "./pages/authentication/RootGoogleHandler";

const Loadable = (Component: LazyExoticComponent<FC>) => (props: any) =>
(
  <Suspense fallback>
    <Component {...props} />
  </Suspense>
);

// Dashboard pages
const DashboardSaaS = Loadable(lazy(() => import("./pages/dashboard/SaaS")));

const UsefulLinks = Loadable(
  lazy(() => import("./pages/linksManagement/UsefulLinks"))
);

const QueueManagement = Loadable(
  lazy(() => import("./pages/queueManagement/QueueManagement"))
);

const AdminLogin = Loadable(
  lazy(() => import("./pages/admin/AdminLogin"))
);

const Clouditools = Loadable(
  lazy(() => import("./pages/clouditools/Home"))
);

const GoogleCallback = Loadable(
  lazy(() => import("./pages/authentication/GoogleCallback"))
);

// error
const Error = Loadable(lazy(() => import("./pages/404")));

const Assignment = Loadable(
  lazy(() => import("./pages/assignment/Assignment"))
);

const AdoptionOpportunities = Loadable(
  lazy(() => import("./pages/adoptionOpportunities/AdoptionOpportunities"))
);

// routes
const routes = [
  {
    path: "/",
    element: <RootGoogleHandler />,
  },
  {
    path: "/google/callback",
    element: <GoogleCallback />,  
  },
  {
    path: "dashboard",
    element: (
      <AuthGuard>
        <RoleProvider>
          <DashboardLayout children={undefined} />
        </RoleProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <DashboardSaaS />,
      },
      {
        path: "coralogix-query",
        element: <Coralogix />,
      },
      {
        path: "redash-query",
        element: <Redash />,
      },
      {
        path: "jenkins-query",
        element: <Jenkins />,
      },
      {
        path: "links-grid",
        element: <UsefulLinks />,
      },
      {
        path: "adoption-opportunities",
        element: <AdoptionOpportunities />,
      },
      {
        path: "queue-management",
        element: <QueueManagement />,
      },
      {
        path: "clouditools/:tab?",
        element: <Clouditools />,
      },
      {
        path: "clouditools/:tab/:subtab?",
        element: <Clouditools />,
      },
      {
        path: "assignment",
        element: <Assignment />,
      },
      {
        path: "assignment/:tab",
        element: <Assignment />,
      },
      {
        path: "admin",
        element: <AdminLogin />,
      },
      {
        path: "admin/:section",
        element: <AdminLogin />,
      },
    ],
  },
  {
    path: "admin",
    element: <Navigate to="/dashboard/admin" replace />
  },
  {
    path: "*",
    element: <Error />,
  },
];

export default routes;